module.exports = __webpack_public_path__ + "img/19.410b07e8.png";